<div class="director-component">
  <form class="director-form" [formGroup]="formGroup">
    @for (directorFormGroup of directorFormGroups(); track directorFormGroup; let index = $index) {
      <div class="row">
        <div class="col-12">
          <div class="application-subsection-title">Director {{index + 1}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <individual-form
            [mark]="markObservable"
            [withPropertyOwnerAddress]="withPropertyOwnerAddress"
            [showAddressForm]="showAddressForm"
            [showIdentification]="showIdentification"
            [formControl]="directorFormGroupFormControl(directorFormGroup, 'individual')">
          </individual-form>
        </div>
      </div>
      @if (showAssetsAndLiabilities) {
        <personal-assets
          [formControl]="directorFormGroupFormControl(directorFormGroup, 'personalAssets')"
          [mark]="markObservable"
          (events)="onPersonalAssetsEvent($event, directorFormGroup)">
        </personal-assets>
      }
      @if (showAssetsAndLiabilities) {
        <personal-liabilities
          [formControl]="directorFormGroupFormControl(directorFormGroup, 'personalLiabilities')"
          [mark]="markObservable"
          (events)="onPersonalLiabilitiesEvent($event, directorFormGroup)">
        </personal-liabilities>
      }
      @if (index > 0) {
        <div class="row separator-bottom">
          <div class="col-12">
            <button mat-stroked-button color="warn" (click)="onDeleteDirector($event, directorFormGroup)">Delete director</button>
          </div>
        </div>
      }
    }

    <div class="row separator-bottom">
      <div class="col-12">
        <button mat-stroked-button (click)="onAddDirector($event)">
          <span class="mdi mdi-plus" matPrefix></span>
          Add director
        </button>
      </div>
    </div>
  </form>


  <div class="row separator-bottom error-messages">
    @for (errorKey of errorKeys(formArray); track errorKey) {
      <mat-error>
        @if (formArray.touched && formArray.hasError(errorKey)) {
          <message-box type="danger">
            {{errorMessage(formArray, errorKey)}}
          </message-box>
        }
      </mat-error>
    }
  </div>



</div>
